import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CpuLargekIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M19.9999 5.33334H11.9999C8.31992 5.33334 5.33325 8.32001 5.33325 12V20C5.33325 23.68 8.31992 26.6667 11.9999 26.6667H19.9999C23.6799 26.6667 26.6666 23.68 26.6666 20V12C26.6666 8.32001 23.6799 5.33334 19.9999 5.33334ZM23.0133 19.0133C23.0133 21.2267 21.2266 23.0133 19.0133 23.0133H12.9866C10.7733 23.0133 8.98658 21.2267 8.98658 19.0133V12.9867C8.98658 10.7733 10.7733 8.98668 12.9866 8.98668H18.9999C21.2133 8.98668 22.9999 10.7733 22.9999 12.9867V19.0133H23.0133Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M12.0801 3.66666V5.33332H12.0001C11.3334 5.33332 10.6934 5.42666 10.0801 5.61332V3.66666C10.0801 3.11999 10.5201 2.66666 11.0801 2.66666C11.6267 2.66666 12.0801 3.11999 12.0801 3.66666Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M17 3.66666V5.33332H15V3.66666C15 3.11999 15.4533 2.66666 16 2.66666C16.5467 2.66666 17 3.11999 17 3.66666Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M21.9334 3.66666V5.61332C21.32 5.42666 20.6667 5.33332 20 5.33332H19.9333V3.66666C19.9333 3.11999 20.3867 2.66666 20.9333 2.66666C21.48 2.66666 21.9334 3.11999 21.9334 3.66666Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M29.3334 11.0667C29.3334 11.6267 28.8934 12.0667 28.3334 12.0667H26.6667V12C26.6667 11.3333 26.5734 10.68 26.3867 10.0667H28.3334C28.8934 10.0667 29.3334 10.52 29.3334 11.0667Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M29.3334 16C29.3334 16.5467 28.8934 17 28.3334 17H26.6667V15H28.3334C28.8934 15 29.3334 15.44 29.3334 16Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M29.3334 20.9333C29.3334 21.48 28.8934 21.9333 28.3334 21.9333H26.3867C26.5734 21.32 26.6667 20.6667 26.6667 20V19.9333H28.3334C28.8934 19.9333 29.3334 20.3733 29.3334 20.9333Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M21.9334 26.3867V28.3333C21.9334 28.88 21.48 29.3333 20.9333 29.3333C20.3867 29.3333 19.9333 28.88 19.9333 28.3333V26.6667H20C20.6667 26.6667 21.32 26.5733 21.9334 26.3867Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M17.0134 26.6667V28.3333C17.0134 28.88 16.5601 29.3333 16.0134 29.3333C15.4534 29.3333 15.0134 28.88 15.0134 28.3333V26.6667H17.0134Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M12.0801 26.6667V28.3333C12.0801 28.88 11.6267 29.3333 11.0801 29.3333C10.5201 29.3333 10.0801 28.88 10.0801 28.3333V26.3867C10.6934 26.5733 11.3334 26.6667 12.0001 26.6667H12.0801Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M5.61341 10.0667C5.42675 10.68 5.33341 11.3333 5.33341 12V12.0667H3.66675C3.12008 12.0667 2.66675 11.6267 2.66675 11.0667C2.66675 10.52 3.12008 10.0667 3.66675 10.0667H5.61341Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M5.33341 15V17H3.66675C3.12008 17 2.66675 16.5467 2.66675 16C2.66675 15.44 3.12008 15 3.66675 15H5.33341Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M5.61341 21.9333H3.66675C3.12008 21.9333 2.66675 21.48 2.66675 20.9333C2.66675 20.3733 3.12008 19.9333 3.66675 19.9333H5.33341V20C5.33341 20.6667 5.42675 21.32 5.61341 21.9333Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M23.0132 12.9867V19C23.0132 21.2133 21.2266 23 19.0132 23H12.9866C10.7732 23 8.98657 21.2133 8.98657 19V12.9867C8.98657 10.7733 10.7732 8.98666 12.9866 8.98666H18.9999C21.2132 8.98666 23.0132 10.7867 23.0132 12.9867Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_15)
  ]))
}
}

})